export const isNumber = (value: any) => {
  return typeof value === "number" && !isNaN(value);
};

export const isNumberNullable = (value: any): number | null => {
  if (isNumber(value)) {
    return Number(value);
  }
  return null;
};
